import { render, staticRenderFns } from "./SetKnowledgeRestrictions.vue?vue&type=template&id=650981e0&scoped=true&"
import script from "./SetKnowledgeRestrictions.vue?vue&type=script&lang=js&"
export * from "./SetKnowledgeRestrictions.vue?vue&type=script&lang=js&"
import style0 from "./SetKnowledgeRestrictions.vue?vue&type=style&index=0&id=650981e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650981e0",
  null
  
)

export default component.exports